import { defineStyleConfig as t } from "@chakra-ui/react";
const e = {
  fontVariantNumeric: "tabular-nums"
}, o = t({
  baseStyle: e
});
export {
  o as textConfig
};
